var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 82,
    viewBox: "0 0 89 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2656 42.1562H45.7344C54.5278 42.1562 61.6562 49.2847 61.6562 58.0781V69.0625H27.3438V58.0781C27.3438 49.2847 34.4722 42.1562 43.2656 42.1562ZM17.3438 58.0781C17.3438 43.7619 28.9494 32.1562 43.2656 32.1562H45.7344C60.0506 32.1562 71.6562 43.7619 71.6562 58.0781V69.0625V71.5938H84C86.7614 71.5938 89 73.8323 89 76.5938C89 79.3552 86.7614 81.5938 84 81.5938H5C2.23858 81.5938 0 79.3552 0 76.5938C0 73.8323 2.23858 71.5938 5 71.5938H17.3438V69.0625V58.0781Z",
    fill: "white",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2373 19.582L18.5781 30.9229",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 5V22.8213",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7627 19.582L70.4219 30.9229",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellAlert);
export default __webpack_public_path__ + "static/media/bell-alert.f55b36edafee3380522c85fb0f42aa74.svg";
export { ForwardRef as ReactComponent };